var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ClickAwayListener, Collapse, Grow, Paper, Popper } from '@material-ui/core';
import { CheckCircleOutlined, HelpOutlineOutlined, WhatshotOutlined } from '@material-ui/icons';
import { _T, pluralizeNights } from 'appI18n';
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { api } from '../../../../include/network/network';
import { formatMoney } from '../../../../include/utils';
import { toLocationHref } from '../../link-utils';
const conditionsCache = new Map();
function text(key, fallbackKey) {
    return _T[key] || (fallbackKey ? _T[fallbackKey] : key);
}
function getSortedAccomodations(accomodations) {
    return (accomodations !== null && accomodations !== void 0 ? accomodations : [])
        .slice()
        .sort((p1, p2) => p1.checkInDate > p2.checkInDate ? 1 : p1.checkInDate < p2.checkInDate ? -1 : 0);
}
function getCheapestHotelGroupItem(group) {
    return group.items
        .slice()
        .sort((a, b) => a.priceItem.price - b.priceItem.price)[0];
}
function getHotelGroupItemKey(item) {
    var _a;
    return [
        item.tour.id,
        item.tourVariant.id,
        (_a = item.priceItem.priceItem.servicesHash) !== null && _a !== void 0 ? _a : '',
        item.priceItem.accomodationVariants.map(value => value.id).slice().sort().join('|'),
    ].join('|');
}
function groupTourOffers(items, byHotel) {
    const groups = new Map();
    items
        .forEach(item => {
        var _a, _b, _c, _d, _e, _f, _g;
        const firstAccommodation = byHotel ? getSortedAccomodations(item.accomodations)[0] : undefined;
        const checkInDate = (_a = firstAccommodation === null || firstAccommodation === void 0 ? void 0 : firstAccommodation.checkInDate) !== null && _a !== void 0 ? _a : item.tourVariant.checkInDate;
        const duration = (_b = firstAccommodation === null || firstAccommodation === void 0 ? void 0 : firstAccommodation.duration) !== null && _b !== void 0 ? _b : item.tourVariant.duration;
        const id = `${moment(checkInDate).format('YYYY-MM-DD')}|${duration}`;
        const currency = (_f = (_d = (_c = item.tour.currency) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : (_e = item.tourVariant.currency) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : '';
        const dateGroup = (_g = groups.get(id)) !== null && _g !== void 0 ? _g : {
            id,
            checkInDate,
            duration,
            minPrice: item.priceItem.price,
            currency,
            items: [],
        };
        dateGroup.minPrice = Math.min(dateGroup.minPrice, item.priceItem.price);
        dateGroup.items.push(item);
        groups.set(id, dateGroup);
    });
    return Array.from(groups.values())
        .map(group => (Object.assign(Object.assign({}, group), { items: group.items.slice().sort((a, b) => a.priceItem.price - b.priceItem.price) })))
        .sort((a, b) => {
        const dateCompare = moment(a.checkInDate).valueOf() - moment(b.checkInDate).valueOf();
        return dateCompare || a.duration - b.duration;
    });
}
function GagraOffersChevron({ open }) {
    return (React.createElement("span", { className: `gts-result-card__toggle-icon ${open ? '' : 'gts-result-card__toggle-icon--closed'}`, "aria-hidden": "true" },
        React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: "false" },
            React.createElement("path", { d: "M20 16L11.9987 8L4 16", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }))));
}
function uniqueText(values) {
    return values.filter((value, index, array) => !!value && array.indexOf(value) === index).join(', ');
}
function stripHtml(value) {
    return (value !== null && value !== void 0 ? value : '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}
function resolveImageUrl(image) {
    var _a, _b, _c, _d, _e, _f;
    return (_f = (_d = (_b = (_a = image === null || image === void 0 ? void 0 : image.urls) === null || _a === void 0 ? void 0 : _a.large) !== null && _b !== void 0 ? _b : (_c = image === null || image === void 0 ? void 0 : image.urls) === null || _c === void 0 ? void 0 : _c.medium) !== null && _d !== void 0 ? _d : (_e = image === null || image === void 0 ? void 0 : image.urls) === null || _e === void 0 ? void 0 : _e.thumbnail) !== null && _f !== void 0 ? _f : '';
}
function getDateRange(checkInDate, duration) {
    const from = moment(checkInDate);
    const to = from.clone().add(duration, 'days');
    return from.isValid() ? `${from.format('DD.MM.YYYY')} - ${to.format('DD.MM.YYYY')}` : '';
}
function getPenaltySortValue(rule) {
    return rule.from ? moment(rule.from).valueOf() : 9999999999999;
}
function GagraCancellationConditions({ hash, currency }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [conditionsData, setConditionsData] = useState(null);
    const open = !!anchorEl;
    const close = () => setAnchorEl(null);
    const loadConditions = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const cached = conditionsCache.get(hash);
        if (cached) {
            setConditionsData(cached);
            return;
        }
        setLoading(true);
        try {
            const { response, errors } = yield api('get', `/Tour/PaymentAndCancellationConditions/${hash}`, undefined);
            if (errors || !response) {
                setConditionsData({ penaltyCalculationRules: [], cancellationDenied: false });
                return;
            }
            const penaltyCalculationRules = ((_a = response.cancellationRules) !== null && _a !== void 0 ? _a : [])
                .map(rule => {
                var _a, _b, _c, _d, _e;
                const rawCurrency = (_a = rule.currency) !== null && _a !== void 0 ? _a : rule.Currency;
                return {
                    from: (_b = rule.from) !== null && _b !== void 0 ? _b : rule.From,
                    fromString: (_c = rule.fromString) !== null && _c !== void 0 ? _c : rule.FromString,
                    sum: (_d = rule.sum) !== null && _d !== void 0 ? _d : rule.Sum,
                    currencyName: typeof rawCurrency === 'string' ? rawCurrency : (_e = rawCurrency === null || rawCurrency === void 0 ? void 0 : rawCurrency.name) !== null && _e !== void 0 ? _e : rawCurrency === null || rawCurrency === void 0 ? void 0 : rawCurrency.Name,
                    currency,
                };
            })
                .sort((a, b) => getPenaltySortValue(a) - getPenaltySortValue(b));
            const next = { penaltyCalculationRules, cancellationDenied: !!response.cancellationDenied };
            conditionsCache.set(hash, next);
            setConditionsData(next);
        }
        finally {
            setLoading(false);
        }
    });
    const toggle = (event) => __awaiter(this, void 0, void 0, function* () {
        event.preventDefault();
        event.stopPropagation();
        if (anchorEl === event.currentTarget) {
            close();
            return;
        }
        setAnchorEl(event.currentTarget);
        setConditionsData(null);
        yield loadConditions();
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "gts-card-label gts-card-label--link", type: "button", onClick: toggle },
            React.createElement(HelpOutlineOutlined, { fontSize: "small" }),
            React.createElement("span", null, text('GAGRA_TOUR_CANCELLATION_CONDITIONS', 'CANCELLATION_CONDITIONS'))),
        React.createElement(Popper, { open: open, anchorEl: anchorEl, placement: "bottom-start", transition: true, className: "gts-card-popover" }, ({ TransitionProps }) => (React.createElement(Grow, Object.assign({}, TransitionProps, { timeout: 160 }),
            React.createElement(Paper, { className: "gts-card-popover__paper" },
                React.createElement(ClickAwayListener, { onClickAway: close },
                    React.createElement("div", { className: "gts-card-popover__content" },
                        React.createElement("button", { className: "gts-card-popover__close", type: "button", "aria-label": text('COMMON_CLOSE'), onClick: close }, "\u00D7"),
                        React.createElement("h4", null, text('GAGRA_TOUR_CANCELLATION_CONDITIONS', 'CANCELLATION_CONDITIONS')),
                        loading || !conditionsData
                            ? React.createElement("p", { className: "gts-card-popover__muted" }, text('COMMON_LOADING'))
                            : React.createElement(React.Fragment, null,
                                conditionsData.cancellationDenied ? React.createElement("p", null, _T.TOUR_SEARCH_NONREF_BADGE_TITLE || _T.CANCELLATION_CONDITIONS) : null,
                                !conditionsData.cancellationDenied && !conditionsData.penaltyCalculationRules.length ? React.createElement("p", null, _T.CANCELLATION_FREE) : null,
                                conditionsData.penaltyCalculationRules.map((rule, index) => {
                                    var _a, _b;
                                    const penaltyCurrency = (_b = (_a = rule.currencyName) !== null && _a !== void 0 ? _a : rule.currency) !== null && _b !== void 0 ? _b : currency;
                                    const from = rule.fromString ? rule.fromString : rule.from ? moment(rule.from).format('DD.MM.YYYY') : '';
                                    return (React.createElement("div", { className: "gts-card-popover__row", key: `${index}-${from}` },
                                        React.createElement("span", null, from ? `${_T.CANCELLATION_FROM} ${from}` : _T.CANCELLATION_PENALTY),
                                        React.createElement("strong", null, rule.sum !== undefined ? `${formatMoney(rule.sum, { currency: penaltyCurrency })} ${penaltyCurrency}` : '')));
                                }))))))))));
}
function buildViewModel(props) {
    var _a, _b, _c;
    if (props.hotelGroup) {
        const cheapest = getCheapestHotelGroupItem(props.hotelGroup);
        if (!cheapest)
            return undefined;
        return {
            sourceTour: cheapest.tour,
            images: ((_a = props.hotelGroup.images) === null || _a === void 0 ? void 0 : _a.length) ? props.hotelGroup.images : (_b = cheapest.tour.images) !== null && _b !== void 0 ? _b : [],
            title: props.hotelGroup.hotelName,
            location: uniqueText([props.hotelGroup.countryName, props.hotelGroup.cityName]),
            description: stripHtml(props.hotelGroup.description),
            staticHotelUrl: props.hotelGroup.staticHotelUrl,
            tourVariant: cheapest.tourVariant,
            priceItem: cheapest.priceItem,
            accomodations: getSortedAccomodations(cheapest.accomodations),
        };
    }
    const result = props.item.findCheapestTourVariant();
    if (!result)
        return undefined;
    const [tourVariant, priceItem] = result;
    if (!priceItem)
        return undefined;
    const accomodations = getSortedAccomodations(priceItem.accomodationVariants);
    const hotel = accomodations[0];
    return {
        sourceTour: props.item,
        images: (_c = props.item.images) !== null && _c !== void 0 ? _c : [],
        title: props.item.name,
        location: props.item.directionName,
        description: stripHtml(props.item.description),
        staticHotelUrl: hotel === null || hotel === void 0 ? void 0 : hotel.staticHotelUrl,
        tourVariant,
        priceItem,
        accomodations,
    };
}
export function GagraTourSearchResultCard(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const [offersOpen, setOffersOpen] = useState(false);
    const [offerGroupId, setOfferGroupId] = useState();
    const viewModel = useMemo(() => buildViewModel(props), [props.item, props.hotelGroup]);
    const offerGroups = useMemo(() => {
        if (props.hotelGroup)
            return groupTourOffers(props.hotelGroup.items, true);
        const tour = props.item;
        return groupTourOffers(tour.variants.flatMap(tourVariant => tourVariant.priceVariants.map(priceItem => ({
            tour,
            tourVariant,
            priceItem,
            accomodations: getSortedAccomodations(priceItem.accomodationVariants),
        }))), false);
    }, [props.item, props.hotelGroup]);
    const activeOfferGroup = useMemo(() => { var _a; return (_a = offerGroups.find(group => group.id === offerGroupId)) !== null && _a !== void 0 ? _a : offerGroups[0]; }, [offerGroups, offerGroupId]);
    if (!viewModel)
        return null;
    const { sourceTour, tourVariant, priceItem, accomodations } = viewModel;
    const price = priceItem.price;
    const currency = (_d = (_b = (_a = sourceTour.currency) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : (_c = tourVariant.currency) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
    const firstAccomodation = accomodations[0];
    const stayDuration = props.hotelGroup ? (_e = firstAccomodation === null || firstAccomodation === void 0 ? void 0 : firstAccomodation.duration) !== null && _e !== void 0 ? _e : tourVariant.duration : tourVariant.duration;
    const stayCheckInDate = props.hotelGroup ? (_f = firstAccomodation === null || firstAccomodation === void 0 ? void 0 : firstAccomodation.checkInDate) !== null && _f !== void 0 ? _f : tourVariant.checkInDate : tourVariant.checkInDate;
    const offersId = `gts-tour-offers-${props.hotelGroup ? `hotel-${props.hotelGroup.id}` : `tour-${sourceTour.id}`}`;
    const offerNameLabel = props.hotelGroup ? _T.COMMON_TOUR : _T.COMMON_HOTEL;
    const dateRange = getDateRange(stayCheckInDate, stayDuration);
    const duration = `${stayDuration} ${pluralizeNights(stayDuration)}`;
    const room = uniqueText([firstAccomodation === null || firstAccomodation === void 0 ? void 0 : firstAccomodation.roomTypeName, firstAccomodation === null || firstAccomodation === void 0 ? void 0 : firstAccomodation.roomCategoryName]);
    const accommodation = uniqueText(accomodations.map(x => x.accommodationTypeName));
    const meal = uniqueText(accomodations.map(x => x.mealTypeName));
    const imageUrl = resolveImageUrl(viewModel.images[0]);
    const hasImmediateConfirmation = !!priceItem.priceItem.isImmediateConfirmation;
    const hasLastRoom = ((_g = priceItem.priceItem.hotels) !== null && _g !== void 0 ? _g : []).some(hotel => hotel.quota === 1);
    const servicesHash = priceItem.priceItem.servicesHash;
    const offerParameters = [
        { label: text('GAGRA_TOUR_DATES'), value: dateRange },
        { label: text('GAGRA_TOUR_DURATION'), value: duration },
        { label: _T.COMMON_HOTEL, value: props.hotelGroup ? '' : uniqueText(accomodations.map(x => x.hotelName)) },
        { label: text('GAGRA_TOUR_ROOM'), value: room },
        { label: text('GAGRA_TOUR_ACCOMMODATION'), value: accommodation },
        { label: text('GAGRA_TOUR_MEAL'), value: meal },
    ].filter(parameter => !!parameter.value);
    return (React.createElement("article", { className: "gts-result-card" },
        React.createElement("div", { className: "gts-result-card__media" }, imageUrl
            ? React.createElement("img", { src: imageUrl, alt: viewModel.title })
            : React.createElement("div", { className: "gts-result-card__media-placeholder", "aria-hidden": "true" })),
        React.createElement("section", { className: "gts-result-card__hotel" },
            viewModel.location ? React.createElement("p", { className: "gts-result-card__location" },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18", fill: "none" },
                    React.createElement("path", { d: "M9.00002 16.2C9.00002 16.2 14.6348 11.1913 14.6348 7.43477C14.6348 4.32277 12.112 1.79999 9.00002 1.79999C5.88801 1.79999 3.36523 4.32277 3.36523 7.43477C3.36523 11.1913 9.00002 16.2 9.00002 16.2Z", stroke: "#333333", "stroke-opacity": "0.5", "stroke-width": "1.2" }),
                    React.createElement("path", { d: "M10.8002 7.2001C10.8002 8.19421 9.99436 9.0001 9.00025 9.0001C8.00613 9.0001 7.20025 8.19421 7.20025 7.2001C7.20025 6.20599 8.00613 5.4001 9.00025 5.4001C9.99436 5.4001 10.8002 6.20599 10.8002 7.2001Z", stroke: "#333333", "stroke-opacity": "0.5", "stroke-width": "1.2" })),
                viewModel.location) : null,
            React.createElement("h3", null, viewModel.title),
            viewModel.description ? React.createElement("p", { className: "gts-result-card__description" }, viewModel.description) : null,
            React.createElement("div", { className: "gts-result-card__labels" },
                hasImmediateConfirmation ? React.createElement("span", { className: "gts-card-label gts-card-label--success" },
                    React.createElement(CheckCircleOutlined, { fontSize: "small" }),
                    React.createElement("span", null, text('GAGRA_TOUR_INSTANT_CONFIRMATION'))) : null,
                hasLastRoom ? React.createElement("span", { className: "gts-card-label gts-card-label--warning" },
                    React.createElement(WhatshotOutlined, { fontSize: "small" }),
                    React.createElement("span", null, text('GAGRA_TOUR_LAST_ROOM'))) : null,
                servicesHash ? React.createElement(GagraCancellationConditions, { hash: servicesHash, currency: currency }) : null)),
        React.createElement("dl", { className: "gts-result-card__offer" }, offerParameters.map(parameter => (React.createElement("div", { className: "gts-result-card__offer-row", key: parameter.label },
            React.createElement("dt", null, parameter.label),
            React.createElement("dd", null, parameter.value))))),
        React.createElement("footer", { className: "gts-result-card__actions" },
            React.createElement("div", { className: "gts-result-card__price" },
                React.createElement("span", null, _T.COMMON_PRICE),
                React.createElement("strong", null,
                    formatMoney(price, { currency }),
                    " ",
                    currency)),
            React.createElement("button", { className: "gts-result-card__book", type: "button", onClick: () => props.book(tourVariant, priceItem.accomodationVariants, servicesHash) }, text('GAGRA_TOUR_BOOK', 'COMMON_BUY')),
            React.createElement("div", { className: "gts-result-card__action-links" },
                viewModel.staticHotelUrl ? (React.createElement("a", { className: "gts-result-card__hotel-link", href: viewModel.staticHotelUrl, target: "_blank", rel: "noopener noreferrer" }, text('GAGRA_TOUR_HOTEL_DETAILS'))) : null,
                activeOfferGroup ? React.createElement("button", { className: "gts-result-card__toggle", type: "button", "aria-expanded": offersOpen, "aria-controls": offersId, onClick: () => setOffersOpen(value => !value) },
                    React.createElement("span", null, text('GAGRA_OTHER_OFFERS', 'COMMON_MORE')),
                    React.createElement(GagraOffersChevron, { open: offersOpen })) : null)),
        activeOfferGroup ? React.createElement(Collapse, { className: "gts-result-card__variants gts-result-card__variants--tour", in: offersOpen, mountOnEnter: true, unmountOnExit: true },
            React.createElement("section", { className: "gts-result-card__variants-panel", id: offersId },
                React.createElement("div", { className: "gts-result-card__variant-tabs", role: "tablist", "aria-label": text('GAGRA_OTHER_OFFERS', 'COMMON_MORE') }, offerGroups.map(group => (React.createElement("button", { className: `gts-result-card__variant-tab ${group.id === activeOfferGroup.id ? 'gts-result-card__variant-tab--active' : ''}`, type: "button", role: "tab", "aria-selected": group.id === activeOfferGroup.id, key: group.id, onClick: () => setOfferGroupId(group.id) },
                    React.createElement("strong", null,
                        moment(group.checkInDate).format('DD.MM.YYYY'),
                        ", ",
                        group.duration,
                        " ",
                        pluralizeNights(group.duration)),
                    React.createElement("span", null,
                        _T.COMMON_FROM,
                        " ",
                        formatMoney(group.minPrice, { currency: group.currency }),
                        " ",
                        group.currency))))),
                React.createElement("div", { className: "gts-result-card__variant-head", "aria-hidden": "true" },
                    React.createElement("span", null, offerNameLabel),
                    React.createElement("span", null, text('GAGRA_TOUR_ROOM', 'COMMON_ROOM_CATEGORY')),
                    React.createElement("span", null, text('GAGRA_TOUR_ACCOMMODATION', 'COMMON_ACCOMMODATION')),
                    React.createElement("span", null, text('GAGRA_TOUR_MEAL', 'COMMON_MEAL')),
                    React.createElement("span", null, _T.COMMON_AVAILABILITY),
                    React.createElement("span", null, _T.COMMON_PRICE),
                    React.createElement("span", null)),
                React.createElement("div", { className: "gts-result-card__variant-list" }, activeOfferGroup.items.map((item, index) => {
                    var _a, _b, _c, _d;
                    const rooms = uniqueText(item.accomodations.map(value => uniqueText([value.roomTypeName, value.roomCategoryName])));
                    const accommodationText = uniqueText(item.accomodations.map(value => value.accommodationTypeName));
                    const meals = uniqueText(item.accomodations.map(value => value.mealTypeName));
                    const available = item.accomodations.every(value => value.orderAvailability === 'available');
                    const currencyName = (_d = (_b = (_a = item.tour.currency) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : (_c = item.tourVariant.currency) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
                    const offerUrl = props.genUrl(item.tourVariant.id, item.priceItem.accomodationVariants.map(value => value.id), item.priceItem.priceItem.servicesHash, item.tour.name);
                    const offerName = props.hotelGroup ? item.tour.name : uniqueText(item.accomodations.map(value => value.hotelName)) || item.tour.name;
                    return (React.createElement("div", { className: "gts-result-card__variant-row", key: `${getHotelGroupItemKey(item)}-${index}` },
                        React.createElement("div", { className: "gts-result-card__variant-cell" },
                            React.createElement("span", null, offerNameLabel),
                            React.createElement("a", { className: "gts-result-card__variant-link", href: toLocationHref(offerUrl) }, offerName)),
                        React.createElement("div", { className: "gts-result-card__variant-cell" },
                            React.createElement("span", null, text('GAGRA_TOUR_ROOM', 'COMMON_ROOM_CATEGORY')),
                            rooms),
                        React.createElement("div", { className: "gts-result-card__variant-cell" },
                            React.createElement("span", null, text('GAGRA_TOUR_ACCOMMODATION', 'COMMON_ACCOMMODATION')),
                            accommodationText),
                        React.createElement("div", { className: "gts-result-card__variant-cell" },
                            React.createElement("span", null, text('GAGRA_TOUR_MEAL', 'COMMON_MEAL')),
                            meals),
                        React.createElement("div", { className: `gts-result-card__variant-cell gts-result-card__variant-status ${available ? 'gts-result-card__variant-status--success' : 'gts-result-card__variant-status--warning'}` },
                            React.createElement("span", null, _T.COMMON_AVAILABILITY),
                            available ? _T.TOUR_AVAILABLE : _T.TOUR_ONREQUEST),
                        React.createElement("div", { className: "gts-result-card__variant-cell gts-result-card__variant-price" },
                            React.createElement("span", null, _T.COMMON_PRICE),
                            React.createElement("strong", null,
                                formatMoney(item.priceItem.price, { currency: currencyName }),
                                " ",
                                currencyName)),
                        React.createElement("button", { className: "gts-result-card__variant-book", type: "button", onClick: () => props.book(item.tourVariant, item.priceItem.accomodationVariants, item.priceItem.priceItem.servicesHash) }, text('GAGRA_TOUR_BOOK', 'COMMON_BUY'))));
                })))) : null));
}
